// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__knob___3MZyF {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  margin: 0 10px;\n}\n.index__knob___3MZyF input[type='range'] {\n  writing-mode: bt-lr;\n  /* IE */\n  -webkit-appearance: slider-vertical;\n  /* WebKit */\n  margin: 10px 0;\n  cursor: pointer;\n  width: 8px;\n  height: 75px;\n  padding: 0 5px;\n}\n", ""]);
// Exports
exports.locals = {
	"knob": "index__knob___3MZyF"
};
module.exports = exports;
